<template>
    <fragment>
        <fragment v-for="subject in subjects" :key="subject._uid">
            <th colspan="3">
                <div class="subject-title-container">
                    <typo>
                        {{ subject.label.toLowerCase() }}
                    </typo>
                    <v-icon
                        v-if="subjects.length > minNumberOfDisplayedSubjects"
                        class="subject-icon"
                        @click="removeTitle(subject.code)"
                    >
                        mdi-close
                    </v-icon>
                </div>
            </th>
        </fragment>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import { EventBus } from "src/bus/eventBus";

export default {
    components: { Fragment },
    props: ["subjects", "minNumberOfDisplayedSubjects"],
    methods: {
        removeTitle(code) {
            EventBus.$emit(
                "subjectsChanged",
                this.subjects.filter(subject => subject.code !== code)
            );
        },
    },
};
</script>
<style scoped lang="sass">
th
    margin: 10px
.subject-title-container
    margin: 10px 30px
    padding: 10px
    position: relative
    border: 2px solid $color-secondary
    &::first-letter
        text-transform: capitalize

.subject-icon
    color: $color-secondary
    position: absolute
    right: 16px
</style>
